import React, { Component } from 'react';
import { withStyles, Grid, Typography } from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import axios from 'axios'
import { translate } from 'react-i18next';
import { currentHttpOptions } from '../../../common/utilities/utilitiesFunctions';
import ReactSelect from '../../../common/components/UI/Select/ReactSelect';
import DualListBox from '../../../common/components/UI/DualListBox/DualListBoxVirtualized';
import CheckboxWithInfo from '../../components/CheckboxWithInfo/CheckboxWithInfo';
import CustomToolTip from '../../../common/components/UI/ToolTip/ToolTip';
import AdminStepCard from '../../components/AdminStepCard/AdminStepCard';
import RadioButtons from '../../../common/components/UI/RadioGroup/RadioButtons';
import HoursMinutesPicker from '../../../common/components/UI/HoursMinutesPicker/HoursMinutesPicker';
import InputNumber from '../../../common/components/UI/Input/Number';
import { moveSelectedAll, updateIncluded } from '../../../common/components/handlerFunctions';
import { exists, convertMinutesInTimes } from '../../../common/utilities/utilitiesFunctions';
import { isNull } from 'lodash';
import { workplanSettingForm } from '../../styles/settingsStyle';
import { List as VirtualList } from 'react-virtualized';
import { getDefaultAdminValues, NotificationType } from './defaultValues';
import {
    settingMapping, isErrorInNameProperty, stateMapping, makeSubmitPayload, isErrorInForm
} from './form.service';
import AccessProfile from './AccessProfile/AccessProfile';
import NotificationTagsTable from './Notifications/NotificationTagsTable';
import SchedulePeriod from './SchedulePeriod/SchedulePeriod';
import LabeledSelect from '../../components/LabeledSelect/LabeledSelect';
import NotificationStep from './Notifications/NotificationStep';
import { Modal, Button } from "rsuite";
import SettingInformationCard from './InformationCard/SettingInformationCard';
import { AvailabilityType } from '../../Enums/AvailabilityType';
import Coverage from './Coverage/Coverage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import './form.scss';
import DataVisibility from './DataVisibility/DataVisibility';


const styles = (theme) => (workplanSettingForm(theme));

class Form extends Component {
    constructor(props) {
        super(props);

        const { notificationList, action } = props;
        const defaultAdminValues = getDefaultAdminValues(props)

        const setting = !!props.settingSelected
            ? settingMapping(props, defaultAdminValues, notificationList, action)
            : { ...defaultAdminValues }

        this.state = stateMapping(props, setting, this.initDualBox);
        this.dbPaycodes = React.createRef();
        props.displaySpinner(false);

    }

    /**
     * Update property in state.settings
     * @param { string } propName
     * @param { any } prop
     */
    handleSettingPropChange = (propName, prop) =>
        this.setState(prevState => ({ ...prevState, setting: { ...prevState.setting, [propName]: prop } }));

    handleOpenModal = () => this.setState(prevState => ({ ...prevState, isModalOpen: true }));
    handleCloseModal = () => this.setState(prevState => ({ ...prevState, isModalOpen: false }));

    submitForm = () => {

        if (isErrorInForm(this.props.settingList, this.state.setting, this.props.action)) {
            this.setState({ errorSubmitForm: true });
            return;
        }

        const payload = makeSubmitPayload(this.state)
        this.props.handleSubmitForm(payload);
        this.setState({ errorSubmitForm: false });
    }

    handleChangeSetting = async (target, value, section) => {
        if (section !== '') {
            let columns = [];
            if (target === 'dataview') {
                columns = await axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GetDataviewColumns/' + value.value, currentHttpOptions());
                let dataviewColumns = columns.data.map(column => { return { ...column, id: column.value } })

                this.setState(prevState => ({
                    setting: {
                        ...prevState.setting,
                        [section]: {
                            ...prevState.setting[section],
                            [target]: value.value
                        }
                    },
                    dataviewColumns: dataviewColumns,
                    dataviewDual: this.initDualBox(dataviewColumns)
                }))
            } else {
                let split = section.split('.');
                if (split.length === 2) {
                    this.setState(prevState => ({
                        setting: {
                            ...prevState.setting,
                            [split[0]]: {
                                [split[1]]: {
                                    ...prevState.setting[split[0]][split[1]],
                                    [target]: value.value
                                }
                            }
                        }
                    }))
                } else {
                    this.setState(prevState => ({
                        setting: {
                            ...prevState.setting,
                            [section]: {
                                ...prevState.setting[section],
                                [target]: value.value
                            }
                        }
                    }))
                }
            }
        } else {
            this.setState(prevState => ({
                setting: {
                    ...prevState.setting,
                    [target]: value.value
                }
            }))
        }
    }


    initDualBox = (data, selectedValues = []) => {
        let included = [];
        let excluded = [];
        let includedIds = [];
        let excludedIds = [];

        for (const [i, o] of data.entries()) {
            if (selectedValues.indexOf(o.value) > -1) {
                included.push(o);
                includedIds.push(i);
            } else {
                excluded.push(o);
                excludedIds.push(i);
            }
        }

        return {
            included,
            excluded,
            includedIds,
            excludedIds
        };
    }

    radioHandleChange = (event, section) => {
        let name = event.target.name;
        let value = event.target.value;

        this.setState(prevState => ({
            setting: {
                ...prevState.setting,
                [section]: {
                    ...prevState.setting[section],
                    [name]: value
                }
            }
        }))
    }

    generateInputs = (labelTypo, placeholder, value, list, section, target, disabled = false) => {
        const { classes } = this.props;

        return <div className={classes.fieldWidth}>
            <ReactSelect
                labelText={labelTypo}
                placeholder={placeholder}
                value={typeof value !== 'undefined' ? value : ''}
                options={list}
                onChange={this.handleChangeSetting}
                target={target}
                isDisabled={disabled}
                extraOnChange={section}
                error={(!isNull(value) && isNull(value.label)) || !value}
            />
        </div>
    }

    handleCheck = (section, target) => {
        this.setState(prevState => ({
            setting: {
                ...prevState.setting,
                [section]: {
                    ...prevState.setting[section],
                    [target]: !prevState.setting[section][target]
                }
            }
        }))
    }

    handleShiftDuration = (hours, minutes, name) => {
        const { setting } = this.state;

        let shiftTemplatesList = setting.shiftHours.shiftTemplates.map(row => {
            if (row.label === name) {
                row.customDuration = hours * 60 + minutes;
            }
            return row;
        })

        this.setState(prevState => ({
            setting: {
                ...prevState.setting,
                shiftHours: {
                    ...prevState.setting.shiftHours,
                    shiftTemplates: shiftTemplatesList
                }
            }
        }))
    }

    generateRowShiftTemplateInputs = ({ key, index, style }) => {
        const { classes } = this.props;
        const { setting } = this.state;
        let first = index * 3;
        let last = (first + 3) <= setting.shiftHours.shiftTemplates.length - 1 ? first + 3 : setting.shiftHours.shiftTemplates.length - 1;
        let shiftTemplates = setting.shiftHours.shiftTemplates.slice(first, last);

        return (<Grid container style={style} >
            {
                shiftTemplates.map((template, i) => {
                    return (<Grid key={'shiftTemplatecontainer' + i + first} container className={classes.shiftTemplateBorder} item xs={4} >
                        <Grid item xs={5}>
                            <div className={classes.divLabelShiftTemplateNames}>
                                <CustomToolTip titletext={<label className={classes.labelShiftTemplateNames}>{template.label}</label>} jsx={<div>{template.label}</div>} />
                            </div>
                        </Grid>
                        <Grid item xs={3} className={classes.elementCentered}>{convertMinutesInTimes(template.duration)}</Grid>
                        <Grid item xs={4} className={classes.elementCentered}>
                            <HoursMinutesPicker
                                nbHours={Math.floor(template.customDuration / 60)}
                                nbMinutes={template.customDuration % 60}
                                handleChange={this.handleShiftDuration}
                                name={template.label}
                            />
                        </Grid>
                    </Grid >)
                })
            }
        </ Grid >
        )
    }

    generateHeaderShiftTemplateInputs = () => {
        const { classes, t } = this.props;
        return (
            <Grid container className={classes.shiftTemplateBorder} item xs={4}>
                <Grid item xs={6}>{t('workplanManager:settings.label')}</Grid>
                <Grid item xs={3} className={classes.headerCentered}>{t('workplanManager:settings.scheduledTime')}</Grid>
                <Grid item xs={3} className={classes.headerCentered}>{t('workplanManager:settings.actualTime')}</Grid>
            </Grid>
        );
    }

    generateCheckboxWithLabel = (checked, section, state, label, disabled = false, tipInfo = "") => {
        const { setting } = this.state;
        const { classes } = this.props;
        const currentSectionValue = setting[section] || {};
        const handleCheckboxChange = (event) => this.handleSettingPropChange(
            section,
            { ...currentSectionValue, [state]: event.target.checked }
        );

        var tipInfoFormatted = []; 
        if (tipInfo !== ""){
            tipInfoFormatted = tipInfo.split(" \n ");
        }

        return (
                <div>
                    <CheckboxWithInfo
                        checked={checked}
                        disabled={disabled}
                        label={label}
                        onChange={handleCheckboxChange}
                    />
                    {!!tipInfo ? (<p className='checkboxTip'><small className={classes.maxLength}>{tipInfoFormatted[0]}</small></p>) : null}
                    {!!tipInfo.includes(" \n ") ? (<p className='secondCheckboxTip'><small className={classes.maxLength}>{tipInfoFormatted[1]}</small></p>) : null}
                </div>
        );
    }

    generateDualBox = (header, selectedLabel, availableLabel, value, target, ref, data) => {
        return <DualListBox
            data={data}
            dataExcluded={value.excluded}
            dataSelected={value.included}
            dataIds={value.excluded}
            dataSelectedIds={value.included}
            subHeader={header}
            target={target}
            moveSelectedAll={moveSelectedAll(this)}
            updateIncluded={updateIncluded(this)}
            rightBoxText={selectedLabel}
            leftBoxText={availableLabel}
            selectableItem={true}
            ref={ref}
        />
    }

    renderColumnSetCard = (stepNum) => {
        const { t, data } = this.props;
        const { dataviewColumns, dataviewDual, setting } = this.state;
        let dataview = data.dataviews.find(y => y.value === setting.columnSet.dataview);

        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.stepTitles.displayData')} >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {this.generateInputs(t('workplanManager:settings.selectDefaultDataview'), t('workplanManager:settings.selectDefaultDataview'), exists(dataview) ? dataview : '', data.dataviews, 'columnSet', 'dataview')}
                </Grid>
                <Grid item xs={12}>
                    {this.generateDualBox(t('workplanManager:settings.selectDefaultDataview'), t('workplanManager:settings.visible'), t('workplanManager:settings.hidden'), dataviewDual, 'dataviewDual', 'dataviews', dataviewColumns)}
                </Grid>
            </Grid>
        </AdminStepCard>
    }

    renderTemplateOptionCard = (stepNum) => {
        const { classes, t, data } = this.props;
        const { setting } = this.state;

        let radiosOrgPathMode = [
            { value: 'singleOrgPath', label: t('workplanManager:settings.columnsSetUnassignedLineOnTop') },
            { value: 'multiOrgPath', label: t('workplanManager:settings.columnsSetUnassignedLineOnBottom') }
        ];
        let wpOpt = setting.workplanTemplateOptions;
        let scheduleRule = data.scheduleRuleSets.find(y => y.value === wpOpt.scheduleRule);

        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.workplanTemplateOptions')} >
            {this.generateInputs(t('workplanManager:settings.selectScheduleRules'), t('workplanManager:settings.selectScheduleRules'), exists(scheduleRule) ? scheduleRule : '', data.scheduleRuleSets, 'workplanTemplateOptions', 'scheduleRule')}
            {this.generateCheckboxWithLabel(wpOpt.usePatternTemplate, 'workplanTemplateOptions', 'usePatternTemplate', t('workplanManager:settings.usePatternTemplate'))}
            {this.generateCheckboxWithLabel(wpOpt.createPatternTemplate, 'workplanTemplateOptions', 'createPatternTemplate', t('workplanManager:settings.createPatternTemplate'))}
            <RadioButtons color="primary" name="orgPathMode" value={wpOpt.orgPathMode} extraOnChange={'workplanTemplateOptions'} onChange={this.radioHandleChange} radios={radiosOrgPathMode} formControlClass={classes.divRadio} />
            {this.generateCheckboxWithLabel(wpOpt.modifyTemplate, 'workplanTemplateOptions', 'modifyTemplate', t('workplanManager:settings.modifyTemplate'))}
            {this.generateCheckboxWithLabel(wpOpt.pauseTemplate, 'workplanTemplateOptions', 'pauseTemplate', t('workplanManager:settings.pauseTemplate'))}
            {this.generateCheckboxWithLabel(wpOpt.stopTemplate, 'workplanTemplateOptions', 'stopTemplate', t('workplanManager:settings.stopTemplate'))}
        </AdminStepCard>

    }

    renderActualShiftHoursCard = (stepNum) => {
        const { classes, t } = this.props;
        const { dataviewColumns, setting } = this.state;

        let radiosYearType = [
            { value: 'days', label: t('workplanManager:settings.days') },
            { value: 'weeks', label: t('workplanManager:settings.weeks') }
        ];

        let shiftHours = setting.shiftHours;
        let yearTotalColumn = dataviewColumns.find(y => y.value === shiftHours.yearTotalColumn);
        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.setActualShiftHours')} >
            {this.generateCheckboxWithLabel(shiftHours.enableTotalYearCalculation, 'shiftHours', 'enableTotalYearCalculation', t('workplanManager:settings.enableTotalYearHoursCalc'))}

            <div className={classes.divYearLenght}>
                <InputNumber min={1} max={999} step={1} precision={0}
                    value={shiftHours.yearDuration}
                    strict={true}
                    label={t('workplanManager:settings.consistYear')}
                    disabled={!shiftHours.enableTotalYearCalculation}
                    handleChangeInput={(value) => { this.handleChangeSetting('yearDuration', { value: value }, 'shiftHours') }}
                />
                <RadioButtons disabled={!shiftHours.enableTotalYearCalculation} color="primary" name="yearType" value={shiftHours.yearType} onChange={this.radioHandleChange} extraOnChange={'shiftHours'} radios={radiosYearType} formControlClass={classes.divRadioYearType} />
            </div>

            {this.generateInputs(t('workplanManager:settings.selectDataColumnForYearCalculation'), t('workplanManager:settings.selectDataColumnForYearCalculation'), exists(yearTotalColumn) ? yearTotalColumn : '', dataviewColumns, 'shiftHours', 'yearTotalColumn', !shiftHours.enableTotalYearCalculation)}

            <div>
                <KeyboardDatePicker
                    className={classes.yearDatePicker}
                    disabled={!shiftHours.enableTotalYearCalculation}
                    disableToolbar
                    variant="inline"
                    format={'YYYY-MM-DD'}
                    margin="normal"
                    id="date-picker-inline"
                    label={t('workplanManager:settings.setEffectiveDateForYearCalculation')}
                    value={shiftHours.effectiveDateForYearCalculation}
                    onChange={(event, picker) => {
                        this.handleChangeSetting('effectiveDateForYearCalculation', { value: picker }, 'shiftHours')
                    }}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </div>

            {t('workplanManager:settings.setActualShiftHours')}
            <div style={{ marginTop: 15 }}>
                <Grid container spacing={3} >
                    <div className={classes.shiftTemplateHeader}>
                        {this.generateHeaderShiftTemplateInputs()}
                        {this.generateHeaderShiftTemplateInputs()}
                        {this.generateHeaderShiftTemplateInputs()}
                    </div>

                    <VirtualList className={classes.shiftTemplateVirtualList}
                        width={15000}
                        height={176}
                        rowHeight={38}
                        rowRenderer={this.generateRowShiftTemplateInputs}
                        rowCount={setting.shiftHours.shiftTemplates.length / 3}
                        noRowsRenderer={this.noRowsRenderer}
                        overscanRowCount={3}
                    />
                </Grid>
            </div>
        </AdminStepCard>
    }

    renderEmployeeAssignmentCard = (stepNum) => {
        const { t, data } = this.props;
        const { paycodesDual, setting } = this.state;

        let eeAssignment = setting.employeeAssignement;

        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.employeeAssignment')} >
            {this.generateCheckboxWithLabel(eeAssignment.allowToEdit, 'employeeAssignement', 'allowToEdit', t('workplanManager:settings.allowToEditEmployeeAssignments'))}
            {this.generateCheckboxWithLabel(eeAssignment.allowToStop, 'employeeAssignement', 'allowToStop', t('workplanManager:settings.allowToStopEmployee'))}
            {this.generateCheckboxWithLabel(eeAssignment.allowToPause, 'employeeAssignement', 'allowToPause', t('workplanManager:settings.allowToPauseEmployee'))}
            {this.generateCheckboxWithLabel(eeAssignment.enableAutoStopTerminated, 'employeeAssignement', 'enableAutoStopTerminated', t('workplanManager:settings.enableAutoStopWhenTerminatedEmployee'))}
            {this.generateCheckboxWithLabel(eeAssignment.enableAutoPauseInactive, 'employeeAssignement', 'enableAutoPauseInactive', t('workplanManager:settings.enableAutoPauseWhenInactiveEmployee'))}
            {this.generateCheckboxWithLabel(eeAssignment.enableAutoPauseWithPayCode, 'employeeAssignement', 'enableAutoPauseWithPayCode', t('workplanManager:settings.enableAutoPauseWhenPayCodeScheduled'))}

            {this.generateDualBox(t('workplanManager:settings.selectDefaultDataview'), t('workplanManager:settings.availablePaycodes'), t('workplanManager:settings.selectedPaycodes'), paycodesDual, 'paycodesDual', this.dbPaycodes, data.payCodes)}
        </AdminStepCard>
    }

    renderShiftLineOptionCard = (stepNum) => {
        const { t } = this.props;
        const { setting } = this.state;

        let slOptions = setting.shiftLineOptions;

        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.shiftLineOption')} >
            {this.generateCheckboxWithLabel(slOptions.allowAddNew, 'shiftLineOptions', 'allowAddNew', t('workplanManager:settings.allowAddNew'))}
            {this.generateCheckboxWithLabel(slOptions.allowEdit, 'shiftLineOptions', 'allowEdit', t('workplanManager:settings.allowEdit'))}
            {this.generateCheckboxWithLabel(slOptions.allowDelete, 'shiftLineOptions', 'allowDelete', t('workplanManager:settings.allowDelete'))}
        </AdminStepCard>
    }

    renderWarningCard = (stepNum) => {
        const { t } = this.props;
        const { setting } = this.state;

        const { requiredSkillsCheck, requiredCertificationsCheck, expiredCertificationsCheck,
            overlappingEmployeesCheck, overlappingOnDifferentWorkplansCheck } = setting.warning

        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.warning.title')} >
            {this.generateCheckboxWithLabel(requiredSkillsCheck, 'warning', 'requiredSkillsCheck', t('workplanManager:settings.warning.requiredSkills'))}
            {this.generateCheckboxWithLabel(requiredCertificationsCheck, 'warning', 'requiredCertificationsCheck', t('workplanManager:settings.warning.requiredCertifications'))}
            {this.generateCheckboxWithLabel(expiredCertificationsCheck, 'warning', 'expiredCertificationsCheck', t('workplanManager:settings.warning.expiredCertifications'))}
            {this.generateCheckboxWithLabel(overlappingEmployeesCheck, 'warning', 'overlappingEmployeesCheck', t('workplanManager:settings.warning.overlappingEmployees'))}
            {this.generateCheckboxWithLabel(overlappingOnDifferentWorkplansCheck, 'warning', 'overlappingOnDifferentWorkplansCheck', t('workplanManager:settings.warning.overlappingOnDifferentWorkplans'))}
        </AdminStepCard>
    }

    renderShiftBiddingIntegrationCard = (stepNum) => {
        const { classes, t, notificationList, data } = this.props;
        const { setting } = this.state;
        const { enableShiftBiddingIntegration, allowOwnerToBeAssignedToConcurentWorkplan } = setting.shiftBiddingIntegration;
        const { allowSchedulePatternTemplateOverride } = setting.importation

        const handleSelectChange = (value) => this.handleSettingPropChange('notifications', { ...setting.notifications, stopOwner: { type: NotificationType.STOP_OWNER, templateId: value } })
        
        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.shiftBiddingIntegration')} >
            {
                this.generateCheckboxWithLabel(enableShiftBiddingIntegration, 'shiftBiddingIntegration', 'enableShiftBiddingIntegration', t('workplanManager:settings.enableShiftBiddingIntegration'), !data.isScheduleBiddingEnable, t('workplanManager:settings.enableShiftBiddingIntegrationDesc'))
            }
            {
                enableShiftBiddingIntegration ?
                    (
                        <div>
                            {this.generateCheckboxWithLabel(allowOwnerToBeAssignedToConcurentWorkplan && enableShiftBiddingIntegration, 'shiftBiddingIntegration', 'allowOwnerToBeAssignedToConcurentWorkplan', t('workplanManager:settings.allowOwnerToBeAssignedToConcurentWorkplan'), allowSchedulePatternTemplateOverride, t('workplanManager:settings.allowOwnerToBeAssignedToConcurentWorkplanDesc'))}
                            <br />
                            <div className={classes.containerLabels}>
                                <Typography style={{ marginBottom: "10px" }} color="textSecondary">{t('workplanManager:settings.managerNotification')}</Typography>
                            </div>
                            <Grid item xs={12}>
                                <LabeledSelect
                                    options={notificationList}
                                    label={t('workplanManager:settings.notificationList.autoStop')}
                                    value={setting.notifications.stopOwner.templateId}
                                    size="lg"
                                    handleChange={handleSelectChange}
                                    sorted
                                    placeholder={t('workplanManager:settings.placeholders.templates')}
                                    placement="auto" //could be put directly in the component to be applied at all times, would we want that?
                                />
                            </Grid>
                        </div>
                    )
                    : null
            }

        </AdminStepCard>

    }

    renderImportationCard = (stepNum) => {
        const { classes, t, data } = this.props;
        const { setting } = this.state;
        const { allowCSVImport, allowSchedulePatternTemplateOverride, availabilityTemplateType, scheduleTagId } = setting.importation;

        // Availability template type options
        const availabilityTemplateTypeOptions = [
            { value: null, label: t('workplanManager:settings.importation.availabilityTemplateTypeNone') },
            { value: AvailabilityType.Available, label: t('workplanManager:settings.importation.availabilityTemplateTypeAddAvailable') },
            { value: AvailabilityType.Unavailable, label: t('workplanManager:settings.importation.availabilityTemplateTypeAddUnavailable') },
            { value: AvailabilityType.PreferredAvailable, label: t('workplanManager:settings.importation.availabilityTemplateTypeAddPreferredAvailable') },
            { value: AvailabilityType.PreferredUnavailable, label: t('workplanManager:settings.importation.availabilityTemplateTypeAddPreferredUnavailable') }
        ];

        // Schedule tag options (None + options from API)
        const scheduleTagOptions = [
            { value: null, label: t('workplanManager:settings.importation.scheduleTagNone') },
            ...(data.scheduleTags || [])
        ];

        return <AdminStepCard avatar={stepNum} title={t('workplanManager:settings.importation.title')} >
            {this.generateCheckboxWithLabel(allowCSVImport, 'importation', 'allowCSVImport', t('workplanManager:settings.importation.allowExcelImport'))}
            <div>
                <CheckboxWithInfo
                    checked={allowSchedulePatternTemplateOverride}
                    disabled={false}
                    label={t('workplanManager:settings.importation.allowSchedulePatternTemplateOverride')}
                    onChange={this.handleAllowSchedulePatternTemplateOverrideChange}
                />
                {<p className='checkboxTip'><small className={classes.maxLength}>{t('workplanManager:settings.importation.allowSchedulePatternTemplateOverrideInfo')}</small></p>}
            </div>
            <div className={classes.selectWithTooltip}>
                <LabeledSelect
                    label={
                        <span>
                            {t('workplanManager:settings.importation.availabilityTemplateType')}
                            <CustomToolTip
                                titletext={t('workplanManager:settings.importation.availabilityTemplateTypeInfo')}
                                jsx={
                                    <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                        <FontAwesomeIcon
                                            icon={faInfoCircle}
                                            style={{ color: '#357ebd' }}
                                        />
                                    </span>
                                }
                            />
                        </span>
                    }
                    options={availabilityTemplateTypeOptions}
                    value={availabilityTemplateType}
                    handleChange={(value) => this.handleImportationSelectChange('availabilityTemplateType', value)}
                    widthSize="lg"
                    searchable={false}
                />
            </div>
            <div className={classes.selectWithTooltip}>
                <LabeledSelect
                    label={
                        <span>
                            {t('workplanManager:settings.importation.scheduleTag')}
                            <CustomToolTip
                                titletext={t('workplanManager:settings.importation.scheduleTagInfo')}
                                jsx={
                                    <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                        <FontAwesomeIcon
                                            icon={faInfoCircle}
                                            style={{ color: '#357ebd' }}
                                        />
                                    </span>
                                }
                            />
                        </span>
                    }
                    options={scheduleTagOptions}
                    value={scheduleTagId}
                    handleChange={(value) => this.handleImportationSelectChange('scheduleTagId', value)}
                    widthSize="lg"
                    searchable={true}
                />
            </div>
        </AdminStepCard>
    }

    handleImportationSelectChange = (target, value) => {
        this.setState(prevState => ({
            setting: {
                ...prevState.setting,
                importation: {
                    ...prevState.setting.importation,
                    [target]: value
                }
            }
        }));
    }
          
    handleAllowSchedulePatternTemplateOverrideChange = () => {
        const { setting } = this.state;
        const { allowSchedulePatternTemplateOverride } = setting.importation;

        this.setState({
            setting: {
                ...setting,
                importation: {
                    ...setting.importation,
                    allowSchedulePatternTemplateOverride: !allowSchedulePatternTemplateOverride
                }, 
                shiftBiddingIntegration: {
                    ...setting.shiftBiddingIntegration,
                    allowOwnerToBeAssignedToConcurentWorkplan: !allowSchedulePatternTemplateOverride
                }
            }
        });
    }


    render() {
        const { classes, t, cancel, data, settingList, action } = this.props;
        const { setting, isModalOpen } = this.state
        const { Title, Body, Footer } = Modal;

        return (
            <div className={classes.formContainer}>
                <div>
                    <SettingInformationCard
                        isErrorInName={isErrorInNameProperty(settingList, setting, action)}
                        setting={setting}
                        action={this.props.action}
                        handleSettingPropChange={this.handleSettingPropChange}
                    />
                    <AccessProfile
                        options={data.hyperfindQueries}
                        setting={setting}
                        handleSettingPropChange={this.handleSettingPropChange}
                    />
                    <SchedulePeriod
                        setting={setting}
                        isDisabled={this.props.action === 'Edit'}
                        handleSettingPropChange={this.handleSettingPropChange}
                    />
                    {this.renderColumnSetCard(4)}
                    <Coverage
                        values={setting.coverage}
                        isUsed={setting.isUsedByWorkplan}
                        handleSettingPropChange={this.handleSettingPropChange}
                    />
                    {this.renderWarningCard(6)}
                    {this.renderImportationCard(7)}
                    <DataVisibility
                        handleSettingPropChange={this.handleSettingPropChange}
                        dataVisibility={setting.dataVisibility}
                        breakRules={setting.breakRules}
                    />
                    <NotificationStep
                        notificationValues={setting.workflowNotifications}
                        handleSettingPropChange={this.handleSettingPropChange}
                        notificationList={this.props.notificationList}
                        openModal={this.handleOpenModal}
                    />
                    {this.renderShiftBiddingIntegrationCard(10)}
                </div>
                <div className="action-container">
                    <Button
                        className='action-button'
                        onClick={this.submitForm}
                        disabled={isErrorInForm(settingList, setting, action)}
                    >
                        {t('workplanManager:settings.save')}
                    </Button>
                    <Button
                        className='action-button'
                        onClick={cancel}
                    >
                        {t('workplanManager:settings.cancel')}
                    </Button>
                </div>
                <Modal
                    open={isModalOpen}
                    onClose={this.handleCloseModal}
                    className="notification-modal"
                    size="md"
                >
                    <Title style={{ textAlign: "center" }}>
                        {t("workplanManager:settings.workflowNotifications.customTags.modalTitle")}
                    </Title>
                    <Body className="modal-body">
                        <NotificationTagsTable />
                    </Body>
                    <Footer>
                        <Button onClick={this.handleCloseModal} appearance="primary">{t('common:Action.ok')}</Button>
                    </Footer>
                </Modal>
            </div>
        );
    }
}

export default translate(['common', 'workplanManager'])(withStyles(styles)(Form));
